// src/App.js
import { Routes, Route } from 'react-router-dom';
import Layout                from './components/Layout';
import Home                  from './pages/Home';
import Case                  from './pages/Case';
import Equipment             from './pages/Equipment';
import ThrillRotEPK          from './pages/ThrillRotEPK';
import Reel                  from './pages/Reel';
import MediaPartnership      from './pages/MediaPartnership';
import OutreachDashboard     from './pages/OutreachDashboard';
import LocalBusinessOutreach from './pages/LocalBusinessOutreach';
import ConcertOutreach       from './pages/ConcertOutreach';
import Photography           from './pages/Photography';
import PasswordGate          from './components/PasswordGate';
import Weddings              from './pages/Weddings';
import Projects              from './pages/Projects';
import FAQ                   from './pages/FAQ';
import Start                 from './pages/Start';

function App() {
  return (
    <Routes>
      {/* Standalone — no nav/header */}
      <Route path="/weddings" element={<Weddings />} />
      <Route path="/content-creation" element={<Start />} />

      {/* Main site with Layout */}
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/"                  element={<Home />} />
            <Route path="/photography"       element={<Photography />} />
            <Route path="/reel"              element={<Reel />} />
            <Route path="/case/:slug"        element={<Case />} />
            <Route path="/equipment"         element={<Equipment />} />
            <Route path="/thrillrot"         element={<ThrillRotEPK />} />
            <Route path="/partnership"       element={<MediaPartnership />} />
            <Route path="/mobile-production" element={<Projects />} />
            <Route path="/faq"               element={<FAQ />} />
            <Route path="/outreach"          element={<PasswordGate><OutreachDashboard /></PasswordGate>} />
            <Route path="/local-outreach"    element={<PasswordGate><LocalBusinessOutreach /></PasswordGate>} />
            <Route path="/concert-outreach"  element={<PasswordGate><ConcertOutreach /></PasswordGate>} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

export default App;
